<template>
  <div>
    <div v-if="loading" class="text-center p-50">
      <i class="fa fa-spin fa-5x fa-spinner"></i>
    </div>
    <div v-else class="block block-bordered">
        <div class="block-header block-header-default">
        </div>
        <div class="block-content p-0">
          <table class="table table-borderless table-striped table-hover">
            <thead>
              <tr>
                <th>Totaal</th>
                <th>Melding tekst</th>
                <th>Merken</th>
                <th>Sales uitgesloten</th>
                <th>Actief</th>
                <th>Acties</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="orderNotification in orderNotifications" :key="orderNotification.id">
                <td> {{orderNotification.amount}} </td>
                <td>  {{orderNotification.notification_text}} </td>
                <td v-if="orderNotification.settings.brands.length !== 0"> 
                  <li v-for="brand in orderNotification.settings.brands" :key="brand">{{brand}}</li>  
                </td>
                <td v-else> Alles </td>
                <td>
                  <label class="css-control css-control-primary css-checkbox">
                    <input type="checkbox" readonly  disabled="disabled" class="css-control-input" :checked="orderNotification.settings.exclude_sale_products">
                    <span class="css-control-indicator"></span>
                  </label>
                </td>
                <td>
                <label class="css-control css-control-primary css-checkbox">
                    <input type="checkbox" readonly  disabled="disabled" class="css-control-input" :checked="orderNotification.status">
                    <span class="css-control-indicator"></span>
                  </label>
                </td>
                <td>
                  <div class="btn-group" role="group">
                    <button class="btn btn-sm btn-secondary  ml-3" @click="select(orderNotification)">Bewerken</button>
                    <button class="btn btn-sm btn-secondary  ml-3" @click="deleteNotification(orderNotification.id)">Verwijderen</button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
    </div>
    <button v-if="!loading" type="submit" class="btn btn-success btn-noborder" @click="openEditModal">
      Nieuwe order notificatie
    </button>
    <order-notification-edit-modal v-if="showEditModal" ref="editModal" :order-notification="selected" @close="refresh"></order-notification-edit-modal>
  </div>
</template>
<script>
import OrderNotificationEditModal from './OrderNotificationEditModal'
import http from '../utils/http'

export default {
  components: { OrderNotificationEditModal },
  data () {
    return {
      orderNotifications: null,
      showEditModal: false,
      loading: false,
      selected: {
        status: true,
        settings: {
          brands: [],
          exclude_sale_products: false
        }
      }
    }
  },
  methods: {
    load () {
      this.loading = true
      this.$api.getOrderNotification()
        .then((result) => {
          this.orderNotifications = result.data
          this.selected = {
            status: true,
            settings: {
              brands: [],
              exclude_sale_products: false
            }
          }

          this.loading = false
        })
        .catch(() => {
          this.$swal('Ehmm...', 'Er is iets misgegaan met het ophalen van de order notificaties. Probeer het opnieuw.', 'warning')
        })
    },
    refresh () {
      this.showEditModal = false
      this.selected = {
        settings: {}
      }
      this.load()
    },
    openEditModal () {
      this.showEditModal = true
    },
    select (orderNotification) {
      this.selected = orderNotification

      this.openEditModal()
    },
    deleteNotification (id) {
      http.delete(`/order-notification/${id}`)
        .then((result) => {
          this.$swal('Hoera 😊', `Order notificatie is verwijderd.`, 'success')
          this.load()
        })
        .catch(() => {
          this.$swal('Ehmm...', 'Er is iets misgegaan bij het verwijderen van de nieuwe order notificatie', 'warning')
        })
    }
  },
  created () {
    this.load()
  }
}
</script>


// WEBPACK FOOTER //
// OrderNotificationTab.vue?624a8138